import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AccessDeniedComponent,
  AcquireTokenErrorComponent,
  ERROR_PATHS,
  ErrorContainerComponent,
  PageNotFoundComponent,
} from '@content-platform/web-angular-shared-util-error-handling';
import { AdAuthGuard } from '@content-platform/web-angular-shared-util-auth';

const routes: Routes = [
  {
    path: 'dashboard',
    canActivate: [AdAuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
    ],
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: ERROR_PATHS.AccessDenied,
    component: AccessDeniedComponent,
  },
  {
    path: ERROR_PATHS.Error,
    component: ErrorContainerComponent,
  },
  {
    path: ERROR_PATHS.TokenError,
    component: AcquireTokenErrorComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
